module.exports = __webpack_public_path__ + "img/list_Story_02.1da5ee60.jpeg";